<template>
  <div class="choose-page-wrapper">
    <van-nav-bar
      title="座位预定"
      fixed
      placeholder
      left-arrow
      @click-left="onClickLeft"
    />

    <section class="book-site-content">
      <BookCalender :current="bookDate"
                    :service-time="serviceTime"
                    :book-number="seatNumber"
                    :day-list="daysList"
                    :select="select"
                    @change="onBookDateChange"/>
      <SeatSelection ref="seatSelection" :book-date="bookDateString" @isClickFull="isFull" />
      <section class="bottom-function-tools">
        <div class="button-wrap flex">
          <div class="book-price">￥ {{ price }}</div>
          <div class="book-days">
            <i class="iconfont icon-chenggong"></i>
            <span class="book-text">日次</span>
          </div>
          <van-button  :disabled="loading"
                      class="book-submit"
                      type="primary"
                      v-if="is_full == 0"
                      @click="onSubmit">确认</van-button>

                       <van-button v-if="is_full == 1 && price != 0.00" :disabled="loading"
                      class="book-submit"
                      type="primary"
                      @click="onTicket">候补</van-button>
        </div>
      </section>
    </section>

    <van-popup v-model="show"
               position="bottom"
               :style="{ height: '80%' }"
    >
      <div class="book-content">
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment';
import { Toast,Dialog } from 'vant';
import Event from '@/utils/Event';
import BookCalender from '@/components/BookCalender.vue';
import SeatSelection from '@/components/SeatSelection.vue';
// eslint-disable-next-line no-unused-vars
import Order from '@/apis/Order';
// eslint-disable-next-line no-unused-vars
import Trains from '@/apis/Trains';

const parseTime = (date, timeString) => {
  const d = moment(date).format('YYYY-MM-DD');
  const result = moment(`${d} ${timeString}`, 'YYYY-MM-DD HH:mm');
  return result;
};

// const parseTime = (timeString) => moment(timeString, 'HH:mm');

export default {
  components: { BookCalender, SeatSelection },
  name: 'choose',
  data() {
    return {
      loading: false,
      seatNumber: undefined,
      show: false,
      bookDate: undefined,
      infoData: {},
      serviceTime: [],
      daysList: [],
      originTime: '',
      select: 0,
      weekMap: [{
        name: '周日',
        id: 7,
      }, {
        name: '周一',
        id: 1,
      }, {
        name: '周二',
        id: 2,
      }, {
        name: '周三',
        id: 3,
      }, {
        name: '周四',
        id: 4,
      }, {
        name: '周五',
        id: 5,
      }, {
        name: '周六',
        id: 6,
      }],
      is_full:0
    };
  },
  created() {
    this.bookDate = moment(this.currentDate); // 默认预定今天的票
    if (this.$route.query.serviceTime) {
      this.serviceTime = this.$route.query.serviceTime.split(',').map((val) => +val);
    }
    if (this.$route.query.originTime) {
      this.originTime = this.$route.query.originTime;
    }
    this.generateDays();
    // 默认选中第一个可用状态
    // eslint-disable-next-line max-len
    this.select = this.daysList.findIndex((item) => item.available && item.moment.diff(this.currentDate) > 0);
    if (this.select > -1) {
      this.bookDate = this.daysList[this.select].moment;
    }
    Event.on('onSeatClick', (val) => {
      this.seatNumber = val;
    });
  },
  beforeDestroy() {
    Event.off('onSeatClick');
  },
  computed: {
    currentDate() {
      return this.$store.state.currentDate;
    },
    bookDateString() {
      return this.bookDate ? this.bookDate.format('YYYY-MM-DD') : moment()
        .format('YYYY-MM-DD');
    },
    isStudent() {
      return this.$store.getters['auth/isStudent'];
    },
    price() {
      return this.$route.query?.price || 0.00;
    },
  },
  methods: {
   isFull(val){
          this.is_full = val;
   },
    checkIsAvailable(index, day) {
      const origin = parseTime(this.bookDate, this.originTime);
      let tag = true;
      if (day === 0) {
        tag = moment().isBefore(origin);
      }
      return this.serviceTime.indexOf(this.weekMap[index].id > -1) && day >= 0 && tag;
    },
    studentIsAvailable() {
      const beforeOneHour = parseTime(this.bookDate, this.originTime).subtract(1, 'hours');
      const beforeQuarterOfAnHour = parseTime(this.bookDate, this.originTime).subtract(1, 'minutes');
      return this.isStudent && moment().isBetween(beforeOneHour, beforeQuarterOfAnHour, null, '[)');
    },
    generateDays() {
      // 生成七天的日期
      const list = [];
      // eslint-disable-next-line no-plusplus

      const bdate = this.bookDate.format('YYYY-MM-DD');

      for (let day = -1; day < 6; day++) {
        const dayMoment = moment().add(day, 'days');
        const weekIndex = dayMoment.weekday();
        const dw = dayMoment.format('YYYY-MM-DD');
        
        list.push({
          moment: dayMoment,
          index: day,
          day: dayMoment.date(),
          weekItem: this.weekMap[weekIndex],
          week: this.weekMap[weekIndex].name,
         // available: this.checkIsAvailable(weekIndex, day),
         available:bdate === dw ? true :false,
        });
      }
      this.daysList = list;
    },
    onBookDateChange(index) {
      this.select = index;
      this.bookDate = this.daysList[index].moment;
      this.$refs.seatSelection.queryResvSeats(this.bookDate.format('YYYY-MM-DD'));
      this.seatNumber = undefined;
    },
    onClickLeft() {
      this.$router.back();
    },
    async freeOnsubmit(){
                this.loading = true;
                const ordering = Toast.loading({
                  message: '预约中...',
                  forbidClick: true,
                });
                const data = {
                  id: this.$route.query.id,
                  date: this.bookDateString,
                  seat_number: this.seatNumber,
                };
                const res = await Order.createOrder(data);
                if (Number(res.code) === 1) {
                  Toast.success('预约成功');

                  setTimeout(() => {
                       this.$router.push({
                           path: '/orderDetail',
                         
                        });
                  }, 2000);
                } else {
                  ordering.clear();
                  this.loading = false;
                  const message = res?.message || '下单失败';
                  Toast.fail(message);
                }
    },
    async onTicket(e){
      e.preventDefault();
      e.stopPropagation();

       if (this.isStudent && !this.studentIsAvailable()) {
          Toast.fail({
            message: '暂时未开启预约，发车前一小时开启预约，请稍后再来!',
            duration: 2300,
          });
          return;
        }
     

      this.loading = true;
          const ordering = Toast.loading({
            message: '补票中...',
            forbidClick: true,
          });
          const data = {
            id: this.$route.query.id,
            date: this.bookDateString,
            seat_number: 0,
          };
          const res = await Order.createTicketOrder(data);
          if (Number(res.code) === 1) {
           
            if(res.data.is_full == 0 ){
               Toast.success('下单成功');
                 setTimeout(() => {
              this.$router.replace({ path: '/order' });
             
            }, 2000);
            }else{
               Toast.success('候补成功，请耐心等待！');
                   setTimeout(() => {
                      this.$router.replace({ path: '/orderDetail' });
                    
                  }, 2000);
            }
            
          } else {
            ordering.clear();
            this.loading = false;
            const message = res?.message || '下单失败';
            Toast.fail(message);
          }


    },
    async onSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.seatNumber && this.seatNumber !== 0) {
        Toast.fail('请先选择座位');
        return;
      }

       if(this.price ==='0.00'){

         if(this.isStudent && ((new Date(this.bookDateString+' '+'06:00')).getTime() > (new Date()).getTime())){
        
              Toast.fail({
              message: '6点之后开启预约，请稍后再来!',
              duration: 2300,
            });
            return; 
          }


      }else{
        
         
          if (this.isStudent && !this.studentIsAvailable()) {
            Toast.fail({
              message: '暂时未开启预约，发车前一小时开启预约，请稍后再来!',
              duration: 2300,
            });
            return;
          }
           
      }

  

       //判断是否免费，如果免费给出提示
       if(this.price ==='0.00'){
        
          Dialog.confirm({
          title: '',
          message:
            '确定预约该座位吗？',
        })
          .then(() => {
            
              this.freeOnsubmit();

          })
          .catch(() => {
            // on cancel
          });

       }else{

            this.loading = true;
                const ordering = Toast.loading({
                  message: '预约中...',
                  forbidClick: true,
                });
                const data = {
                  id: this.$route.query.id,
                  date: this.bookDateString,
                  seat_number: this.seatNumber,
                };
                const res = await Order.createOrder(data);
                if (Number(res.code) === 1) {
                  Toast.success('下单成功');
                  setTimeout(() => {
                    this.$router.replace({ path: '/order' });
                    // this.$router.replace({ path: '/orderDetail' });
                  }, 2000);
                } else {
                  ordering.clear();
                  this.loading = false;
                  const message = res?.message || '下单失败';
                  Toast.fail(message);
                }

       }
       
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";
@import "~@/assets/styles/variable.scss";

.choose-page-wrapper {
  width: 100vw;
  overflow-x: hidden;
}

::v-deep {
  .van-nav-bar__arrow {
    color: #fff;
    font-size: 20px;
  }
}

.book-site-content {
  width: 100%;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.bottom-function-tools {
  flex-basis: 0;
  flex-shrink: 0;
  background: #ffffff;
  box-sizing: border-box;
  padding-top: 0.7rem;
  padding-left: 0.7rem;
  padding-right: 0.7rem;
  @include safe-padding-bottom(0.7rem);
  .card-tips {
    color: #fb4530;
    height: 30px;
    line-height: 30px;
    border-bottom: 0.7px solid #ececec;
  }

  .button-wrap {
    height: 44px;
    display: flex;
    .book-price {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #990033;
      .iconfont {
        margin-right: 0.7rem;
      }
    }
    .book-days {
      padding: 0 20px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 10px;
        margin-right: 5px;
        color: #669999;
      }
      .iconfont {
        color: #669999;
      }
    }
    .book-submit {
      flex-grow: 1;
      background-color: $brand-color;
      border-color: $brand-color;
    }
  }
}

.book-content {
  height: 100%;
  background: #fff;
  background: url("../assets/images/book-position.png") no-repeat;
  background-size: 100% 100%;
}

</style>
